import { Type } from '../../../../../../../types/Survey/Element'
import { Survey } from '../../../../../../../types/Survey/Survey'

const checkForAvailability = (survey: Survey, type: Type) => {
  if (type === Type.DAY_SELECTION) {
    return !!survey.context.amountOfDays && isFinite(survey.context.amountOfDays) && survey.context.amountOfDays > 1
  } else if (type === Type.ORGANIZATION_UNIT_SELECTION) {
    return !!survey.context.organizationUnitList && survey.context.organizationUnitList.length > 0
  } else if (type === Type.ORGANIZATION_UNIT_COOPERATION_SELECTION) {
    return !!survey.context.organizationUnitList && survey.context.organizationUnitList.length > 0
  } else if (type === Type.ORGANIZATION_UNIT_NUMBER_INPUT) {
    return !!survey.context.organizationUnitList && survey.context.organizationUnitList.length > 0
  }
  return true
}

export default checkForAvailability
